import { useNavigationType, useLocation } from 'react-router';

const useBackListener = () => {
  const navType = useNavigationType();
  const location = useLocation();
  return navType;
};

export default useBackListener;
